import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "checkboxChecked",
  "use": "checkboxChecked-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"checkboxChecked\">\n    <!-- Generator: sketchtool 44.1 (41455) - http://www.bohemiancoding.com/sketch -->\n    <title>2D143799-FECB-4556-A4CE-31C518C5765B</title>\n    <desc>Created with sketchtool.</desc>\n    <defs></defs>\n    <g id=\"checkboxChecked_Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"checkboxChecked_ui/checkbox/checked\" stroke-width=\"2\" stroke=\"#FFFFFF\">\n            <g id=\"checkboxChecked_chechbox_checked\">\n                <polyline id=\"checkboxChecked_checked\" points=\"2.5 7 5.5 10 11.5 4\" />\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/checkboxChecked.svg
// module id = 503
// module chunks = 1